import { REDUCER_KEY_AUTH } from "./auth.reducer";
export var getUser = function (state) { return state.auth.user; };
export var hasAccessToken = function (state) { var _a; return ((_a = state.auth) === null || _a === void 0 ? void 0 : _a.hasAccessToken) || false; };
